import { render } from "./BlocksInfoForm.vue?vue&type=template&id=4c6b5b80"
import script from "./BlocksInfoForm.vue?vue&type=script&lang=js"
export * from "./BlocksInfoForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__